import { formValueSelector } from 'redux-form';
import { GENDER } from './constants';
import getTravelerFormSectionName from './travelerFormName';
export const getSelected = form => (state, id) => formValueSelector(form)(state, getTravelerFormSectionName(id, GENDER)) || null;
//# sourceMappingURL=gender.js.map